import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Truck, Calendar, ArrowRight } from '@phosphor-icons/react';
import { fmtDateFR } from '../../utils/dates';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const STATUS = {
  overdue: { label: 'EN RETARD', bg: '#FEE2E2', color: '#991B1B', border: '#DC2626' },
  today:   { label: "AUJOURD'HUI", bg: '#FEF3C7', color: '#92400E', border: '#F59E0B' },
  soon:    { label: '< 7 JOURS', bg: '#FFEDD5', color: '#9A3412', border: '#FB923C' },
};

export const RentalsEndingWidget = ({ wrapStyle = {} }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({ items: [], count: 0 });
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/api/dashboard/rentals-ending-soon`, { withCredentials: true });
      setData(r.data || { items: [], count: 0 });
    } catch { /* noop */ }
    setLoading(false);
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (loading) return <div className="card" style={{ ...wrapStyle, padding: 18 }}>Chargement locations…</div>;
  if (!data.items.length) {
    return (
      <div className="card" style={{ ...wrapStyle, padding: 18 }} data-testid="rentals-ending-empty">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          <Truck size={20} weight="bold" color="#5B21B6" />
          <h3 style={{ margin: 0, fontSize: '1rem' }}>Locations a renvoyer</h3>
        </div>
        <p style={{ margin: 0, fontSize: '0.85rem', color: '#5E5F66' }}>Aucune location ne se termine dans les 7 prochains jours.</p>
      </div>
    );
  }
  return (
    <div className="card" style={{ ...wrapStyle, padding: 18 }} data-testid="rentals-ending-widget">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Truck size={20} weight="bold" color="#5B21B6" />
          <h3 style={{ margin: 0, fontSize: '1rem' }}>Locations a renvoyer ({data.count})</h3>
        </div>
        <span style={{ fontSize: '0.72rem', color: '#5E5F66' }}>Fin sous 7 jours</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {data.items.map(it => {
          const s = STATUS[it.status] || STATUS.soon;
          return (
            <div key={`${it.project_id}-${it.rental_id}`} data-testid={`rental-end-${it.rental_id}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '8px 12px', border: `1px solid ${s.border}`, background: s.bg, borderRadius: 8 }}>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>{it.label}</div>
                <div style={{ fontSize: '0.74rem', color: '#5E5F66', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <span>{it.project_name}</span>
                  {it.rental_company && <span>· {it.rental_company}</span>}
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    <Calendar size={11} /> {fmtDateFR(it.end_date)}
                  </span>
                </div>
              </div>
              <span style={{ fontSize: '0.65rem', fontWeight: 800, color: s.color, background: 'white', padding: '2px 8px', borderRadius: 999, border: `1px solid ${s.border}`, whiteSpace: 'nowrap' }}>
                {it.days_left < 0 ? `${Math.abs(it.days_left)} J RETARD` : it.days_left === 0 ? "AUJOURD'HUI" : `J-${it.days_left}`}
              </span>
              <button className="btn btn-secondary btn-sm" onClick={() => navigate(`/projects?open=${it.project_id}`)} title="Ouvrir le chantier" style={{ padding: '4px 6px' }}>
                <ArrowRight size={13} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RentalsEndingWidget;
